import { PLACEMENTS } from '@rexlabs/tether';
import Tooltip, { TooltipStateful } from './tooltip';
import ControlledTooltip from './controlled-tooltip';
export { PLACEMENTS, TooltipStateful, ControlledTooltip };
export default Tooltip;